import { Icon } from '../Icon/index.js'
import { SvgIcon } from '../Icon/SvgIcon.js'
import { Toggle } from '../Toggle/Toggle.js'

interface Props {
  checked: boolean
  label: string
  icon: JSX.Element
  onChange: (checked: boolean) => void
  onClick: () => void
}
export const ResourceItemToggle = ({
  checked,
  label,
  icon,
  onChange,
  onClick,
}: Props) => {
  return (
    <div
      className="flex-1 h-11 border border-line-subdued rounded-base pl-2 pr-1 py-1.5 bg-surface flex space-s-2 items-center truncate hover:bg-surface-hovered cursor-pointer"
      onClick={onClick}
    >
      <Icon className="text-content-subdued w-5 h-5 shrink-0">{icon}</Icon>
      <span className="text-content-subdued flex-1 text-sm truncate">
        {label}
      </span>
      <div className="flex space-s-1 items-center px-1">
        <div
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <Toggle
            size="sm"
            checked={checked}
            onChange={() => onChange(!checked)}
          />
        </div>
        <SvgIcon
          className="w-4 h-4 shrink-0 text-content-subdued rtl:-scale-x-100"
          name="chevron-right"
        />
      </div>
    </div>
  )
}
